/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const organisationAccessModeSchema = z.enum(['implicit', 'explicit'])

export type OrganisationAccessModeSchema = z.infer<typeof organisationAccessModeSchema>
